import locales from './locales'
import theme from './theme'

const config: Config = {
  theme,
  locales,
}

export default config
